import { useState } from 'react';
import { X, Facebook, Twitter, Linkedin, Mail, Link2, CheckCircle2, Copy, Share2 } from 'lucide-react';
import { buildCarPublicUrl } from '../../utils/carPublicUrl';
import '../AllCss/SocialShare.css';

function SocialShare({ car, onClose }) {
  const [linkCopied, setLinkCopied] = useState(false);
  const carUrl = buildCarPublicUrl(car);
  const shareText = `Check out this ${car.year} ${car.make} ${car.model} for ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(car.price)}!`;
  const shareTitle = `${car.year} ${car.make} ${car.model}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(carUrl);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      // Fallback
      const textArea = document.createElement('textarea');
      textArea.value = carUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    }
  };

  const shareToFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(carUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareToTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(carUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareToLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(carUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareViaEmail = () => {
    const subject = encodeURIComponent(shareTitle);
    const body = encodeURIComponent(`${shareText}\n\nView details: ${carUrl}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  const shareViaNative = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: carUrl,
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Error sharing:', err);
        }
      }
    } else {
      // Fallback to copy link
      handleCopyLink();
    }
  };

  return (
    <div className="social-share-overlay" onClick={onClose}>
      <div className="social-share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="social-share-header">
          <h3>Share this car</h3>
          <button className="social-share-close" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        <div className="social-share-content">
          <div className="social-share-car-info">
            <h4>{car.year} {car.make} {car.model}</h4>
            <p className="social-share-price">
              {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(car.price)}
            </p>
          </div>

          <div className="social-share-buttons">
            {navigator.share && (
              <button className="social-share-btn native" onClick={shareViaNative}>
                <div className="social-share-icon">
                  <Share2 size={24} />
                </div>
                <span>Share</span>
              </button>
            )}
            
            <button className="social-share-btn facebook" onClick={shareToFacebook}>
              <div className="social-share-icon">
                <Facebook size={24} />
              </div>
              <span>Facebook</span>
            </button>

            <button className="social-share-btn twitter" onClick={shareToTwitter}>
              <div className="social-share-icon">
                <Twitter size={24} />
              </div>
              <span>Twitter</span>
            </button>

            <button className="social-share-btn linkedin" onClick={shareToLinkedIn}>
              <div className="social-share-icon">
                <Linkedin size={24} />
              </div>
              <span>LinkedIn</span>
            </button>

            <button className="social-share-btn email" onClick={shareViaEmail}>
              <div className="social-share-icon">
                <Mail size={24} />
              </div>
              <span>Email</span>
            </button>

            <button 
              className={`social-share-btn link ${linkCopied ? 'copied' : ''}`} 
              onClick={handleCopyLink}
            >
              <div className="social-share-icon">
                {linkCopied ? <CheckCircle2 size={24} /> : <Link2 size={24} />}
              </div>
              <span>{linkCopied ? 'Copied!' : 'Copy Link'}</span>
            </button>
          </div>

          <div className="social-share-link-section">
            <label>Or copy this link:</label>
            <div className="social-share-link-input">
              <input type="text" value={carUrl} readOnly />
              <button onClick={handleCopyLink} className="social-share-copy-btn">
                {linkCopied ? <CheckCircle2 size={18} /> : <Copy size={18} />}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SocialShare;

